import { experimentalStyled as styled } from "@mui/material/styles";
import Link from "next/link";
import { useRouter } from "next/router";

const StyledLink = styled(Link)(({ theme, selected }) => {
  let style = {
    padding: "8px 12px",
    borderRadius: "5px",
    fontSize: "1rem",
    fontWeight: "400",
    textDecoration: "none",
    cursor: "pointer",
  };
  if (selected)
    return {
      ...style,
      color: `${theme.palette.custom.primary_button_text} !important`,
      // color: theme.palette.primary.contrastText,
      background: theme.palette.custom.primary_button,
      "&:hover": {
        color: theme.palette.custom.primary_button_text,
        background: theme.palette.custom.primary_button,
      },
    };
  else
    return {
      ...style,
      color: theme.palette.custom.header_text,
      // color: theme.palette.primary.main,
      "&:hover": {
        color: theme.palette.custom.secondary_button_text,
        // backgroundColor: theme.palette.custom.primary_button,
        background: theme.palette.custom.secondary_button_hover,
      },
    };
});
const NavLink = ({ children, item, hasChild, ...rest }) => {
  // const pathname = usePathname(); // in beta docs
  let { pathname } = useRouter();
  return hasChild ? (
    <StyledLink
      as="a"
      key={item?.name}
      {...rest}
      selected={pathname?.startsWith(hasChild ? item?.commonPath : item?.path)}
    >
      {children}
    </StyledLink>
  ) : (
    // <a key={item?.name} {...rest}>
    // </a>
    <StyledLink
      key={item?.name}
      href={
        !hasChild
          ? !item?.redirect
            ? item?.path
            : item?.redirectPath || ""
          : ""
      }
      target={item?.redirect ? "_blank" : "_self"}
      selected={pathname?.startsWith(hasChild ? item?.commonPath : item?.path)}
      {...rest}
    >
      {children}
    </StyledLink>
  );
};
export default NavLink;
